import actionCreator from "./actionCreator";

export default class GenericStore {
    actionCreator = actionCreator;
}
